import { Grid, Typography } from "@mui/material";
import * as React from "react";
import LoginPanel from "../containers/LoginPanel";
import ReturnToLandingPageButton from "../containers/ReturnToLandingPageButton";
import { Query } from "../interfaces";

export const AppBody = ({
  introText,
  appState,
  searchForm,
  children,
  dataViz,
  expand = true,
  backButton,
  login,
  createEditState,
}: {
  introText: React.ReactElement | string;
  children: React.ReactNode;
  appState?: Query;
  searchForm?: React.ReactElement;
  dataViz?: React.ReactElement;
  expand?: boolean;
  backButton?: React.ReactElement;
  login?: boolean;
  createEditState?: boolean;
}) => {
  return (
    <>
      <ReturnToLandingPageButton />
      {!createEditState && backButton}
      {!createEditState && (
        <Grid container spacing={2}>
          <Grid
            item
            sm={login ? 9 : 12}
            xs={12}
            style={{ position: "relative", minHeight: 100 }}
          >
            {introText}
          </Grid>
          {login && (
            <Grid item sm={3} xs={12}>
              <LoginPanel />
            </Grid>
          )}
        </Grid>
      )}
      {appState && appState?.ui.pgcStep === "step1" ? (
        <>
          <Typography
            variant="h2"
            style={{
              paddingTop: "15px",
            }}
          >
            Step 1 - Choose “who” to compare.
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            style={{ paddingBottom: "35px", width: "72%" }}
          >
            Search for institutions and create peer groups to compare, this will
            define the columns of your report. You can make single or multiple
            selections from the results and do multiple searches. You can also
            build peer groups on the fly.
          </Typography>
        </>
      ) : appState && appState?.ui.pgcStep === "step2" ? (
        <>
          <Typography
            variant="h2"
            style={{
              paddingTop: "15px",
            }}
          >
            Step 2 - Arrange the columns of your report
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            style={{ paddingBottom: "35px", width: "72%" }}
          >
            This step allows you order and arrange your selections, which will
            ultimately become the columns of your report, to your satisfaction.
            Also, this is an opportunity to duplicate some columns, which will
            allow you to compare separate timeframes for the same
            institution/peer group later on.
          </Typography>
        </>
      ) : (
        ""
      )}
      <Grid container spacing={2}>
        {searchForm && (
          <Grid item lg={!expand ? 1 : 2.8} md={!expand ? 1 : 4} sm={12}>
            {searchForm}
          </Grid>
        )}
        <Grid
          item
          lg={!searchForm ? 12 : !expand ? 11 : !dataViz ? 9.2 : 6.5}
          md={!searchForm ? 12 : !expand ? 11 : 8}
          sm={12}
        >
          {children}
        </Grid>
        <Grid item md={2.7} sx={{ display: { sm: "none", md: "block" } }}>
          {dataViz}
        </Grid>
      </Grid>
    </>
  );
};
